// extracted by mini-css-extract-plugin
module.exports = {"groupContainer":"styles_groupContainer__bS4x4","input":"styles_input__2_4pd","item":"styles_item__HhonG","post":"styles_post__8wQro","prev":"styles_prev__3eV2r"};